import i18n from '@/plugins/i18n';
export const forms = [
    {
        type: 'multiInput',
        name: 'products',
        default: [{product: null, count: 1}],
        title: 'Kullanılan Ürün Bilgileri',
        modal: ['products'],
        data:['products'],
        inputs:[
            {
                type: 'select',
                name: 'stock',
                title: i18n.t('dealer.servicesForm.product'),
                rules: {required: true},
                modal: ['product'],
                data: ['product'],
                options: {
                    data: [],
                    label: 'name',
                    track: 'id'
                },
                additionalButton: false,
                checkBox: false
            },
            {
                type: 'text',
                name: 'count',
                title: 'Rezerve Edilecek Abone Adeti',
                rules: {required: true, numeric: true},
                modal: ['count'],
                data: ['count'],
                additionalButton: false,
                checkBox: false
            },
        ],
        additionalButton: false,
        checkBox: false
    },
 
]
export default forms;


// WEBPACK FOOTER //
// ./src/pages/General/Dealer/forms/movementProduct.js